import script from "./AssociatedBuilders.vue?vue&type=script&setup=true&lang=js"
export * from "./AssociatedBuilders.vue?vue&type=script&setup=true&lang=js"

import "./AssociatedBuilders.vue?vue&type=style&index=0&id=2dde4017&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dde4017"]])

export default __exports__